module.exports = __webpack_public_path__ + "img/br32.2c644a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br32.jpg
// module id = xNsf
// module chunks = 0